import { Dialog } from "@headlessui/react";

interface DiscardOrderModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDiscard: () => void;
}

const DiscardOrderModal = ({
  isOpen,
  onClose,
  onDiscard,
}: DiscardOrderModalProps) => {
  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div
        className="fixed inset-0 bg-black/45 backdrop-blur-sm"
        aria-hidden="true"
      />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-150 rounded-2xl bg-white md:p-8 p-5 shadow-xl text-center">
          <Dialog.Title className="md:text-2xl text-xl font-semibold text-gray-950">
            Discard Order?
          </Dialog.Title>

          <p className="mt-3 text-sm md:text-base font-normal text-gray-500">
            You've entered information for this order. <br /> If you leave now,
            your changes won't be saved.
          </p>

          <div className="mt-8 flex md:gap-5 gap-3">
            <button
              type="button"
              onClick={onClose}
              className="h-13 w-full rounded-xl text-base font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 cursor-pointer transition-colors"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onDiscard}
              className="h-13 w-full rounded-xl text-base font-medium text-white bg-red-500 hover:bg-red-600 cursor-pointer transition-colors"
            >
              Discard
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default DiscardOrderModal;
